export const mapoUrl = process.env.REACT_APP_MAPO_URL;
export const hubSpotDealUrl = process.env.REACT_APP_HUBSPOT_DEAL_URL;